import { defineStore } from "pinia";
import { useListProductGroups, type ListProductGroupResponse } from "../api/listProductGroups";
import { useProductGroupStore } from "shared/products/groups/stores/productGroupStore";
import { useRefreshStore } from "@/common/composables/refreshStore";

export const useRefereshProductGroupStore = defineStore('refresh-product-groups', () => {
  const listProductGroups = useListProductGroups();
  const store = useProductGroupStore();

  const {
    initialize, refresh
  } = useRefreshStore<ListProductGroupResponse>({
    fetchFromServer() {
      return listProductGroups.execute();
    },
    mergeToStore(response) {
      store.merge(response.groups);
    },
  });

  return {
    initialize,
    refresh
  };
});
